import { FC } from "react"
import { FieldProps } from "@rjsf/core"
import { JSONSchema7 } from "json-schema"
import { CommonParameter } from "./CommonParameter"

export const SwitchParameter: FC<FieldProps> = ({
    formData = { selection: false },
    registry,
    idSchema,
    onChange,
    errorSchema,
    uiSchema,
    required,
    schema,
    disabled
}) => {
    const SchemaField = registry.fields.SchemaField

    const handleSwitch = (state: boolean) => {
        onChange({
            ...formData,
            selection: state
        })
    }

    const handlePropertyChange = (value: any) => {
        onChange({
            ...formData,
            ...value
        })
    }

    const {
        selection: selectionUiSchema,
        "ui:field": uiField,
        ...restUiSchema
    } = uiSchema
    const { selection: selectionFormData, ...restFormData } = formData
    const {
        title,
        description,
        properties: { selection: selectionSchema, ...restSchemaProperties }
    } = schema as JSONSchema7 & { properties: { selection: JSONSchema7 } }

    return (
        <CommonParameter
            title={title}
            description={description}
            required={required}
            containerClassName="flex items-center"
        >
            <>
                {selectionSchema && (
                    <div className="ml-2 mr-6">
                        <SchemaField
                            name="selection"
                            formContext={{}}
                            idPrefix={{}}
                            errorSchema={errorSchema}
                            autofocus={false}
                            readonly={false}
                            required={false}
                            uiSchema={selectionUiSchema}
                            idSchema={idSchema}
                            formData={selectionFormData}
                            onChange={handleSwitch}
                            onBlur={() => {}}
                            onFocus={() => {}}
                            registry={registry}
                            disabled={disabled}
                            schema={selectionSchema}
                        />
                    </div>
                )}
                {selectionFormData && (
                    <div className="w-full">
                        <SchemaField
                            name=""
                            formContext={{}}
                            idPrefix={{}}
                            errorSchema={errorSchema}
                            autofocus={false}
                            readonly={false}
                            required={false}
                            uiSchema={restUiSchema}
                            idSchema={idSchema}
                            formData={restFormData}
                            onChange={handlePropertyChange}
                            onBlur={() => {}}
                            onFocus={() => {}}
                            registry={registry}
                            disabled={!formData?.selection}
                            schema={{
                                properties: restSchemaProperties
                            }}
                        />
                    </div>
                )}
            </>
        </CommonParameter>
    )
}
